import { render, staticRenderFns } from "./ChangeFirstName.vue?vue&type=template&id=26256714&"
import script from "./ChangeFirstName.vue?vue&type=script&lang=js&"
export * from "./ChangeFirstName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports